module.exports = __webpack_public_path__ + "static/media/Colette Stripe King Headboard - 180 cm_Black.2ea79cf8.png";